import { MonitorMediaFilterType } from '@mnd-frontend/graphql-schema';
import { Avatar, SocialAvatars } from '@mnd-frontend/ui/publish/components';

type MediaFeedThumbnailProps = {
  mediaFilterType?: MonitorMediaFilterType;
  thumbnailUrl?: string | null;
  compact?: boolean;
};

const MentionCardAvatar = ({
  mediaFilterType,
  thumbnailUrl,
  compact,
  ...props
}: MediaFeedThumbnailProps) => {
  const socialAvatarSize = compact ? '2rem' : '3rem';

  const largeMediaTypes = [
    MonitorMediaFilterType.Podcast,
    MonitorMediaFilterType.Radio,
    MonitorMediaFilterType.Tv,
    MonitorMediaFilterType.TvPlay,
    MonitorMediaFilterType.TvWeb,
    MonitorMediaFilterType.Youtube,
    MonitorMediaFilterType.Tiktok,
  ];

  if (!mediaFilterType) {
    if (thumbnailUrl) {
      return <Avatar type="thumbnail" image={thumbnailUrl} size={compact ? 'xs' : 'sm'} />;
    }
    return null;
  }

  const isLarge = mediaFilterType ? largeMediaTypes.includes(mediaFilterType) : false;

  switch (mediaFilterType) {
    case MonitorMediaFilterType.Facebook:
      return <SocialAvatars.Facebook {...props} size={socialAvatarSize} />;
    case MonitorMediaFilterType.Twitter:
      return <SocialAvatars.Twitter {...props} size={socialAvatarSize} />;
    case MonitorMediaFilterType.Instagram:
      return <SocialAvatars.Instagram {...props} size={socialAvatarSize} />;
    case MonitorMediaFilterType.Linkedin:
      return <SocialAvatars.LinkedIn {...props} size={socialAvatarSize} />;
    case MonitorMediaFilterType.Tiktok:
      return <SocialAvatars.TikTok {...props} size={socialAvatarSize} />;
    case MonitorMediaFilterType.Youtube:
      return <SocialAvatars.YouTube {...props} size={socialAvatarSize} />;
    case MonitorMediaFilterType.Podcast:
    case MonitorMediaFilterType.Radio:
    case MonitorMediaFilterType.Tv:
    case MonitorMediaFilterType.TvPlay:
    case MonitorMediaFilterType.TvWeb:
    case MonitorMediaFilterType.Print:
    case MonitorMediaFilterType.Web:
    case MonitorMediaFilterType.Blogs:
    case MonitorMediaFilterType.Forums:
    case MonitorMediaFilterType.SocialMedia:
    case MonitorMediaFilterType.Ether:
      if (thumbnailUrl) {
        return (
          <Avatar
            type="thumbnail"
            image={thumbnailUrl}
            size={compact ? 'xs' : isLarge ? 'lg' : 'sm'}
          />
        );
      }
      return <SocialAvatars.Web {...props} size={socialAvatarSize} />;
    default:
      return null;
  }
};

export default MentionCardAvatar;
